// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import ContactCard, { ContactCardProps } from '/react4xp/components/ContactCard'

// types
interface ContactCardsProps {
    className?: string
    isAnimated?: boolean
    title?: string
    intro?: string
    cards?: ContactCardProps[]
}

// css
import './index.scss'

export default function ContactCards({
    className,
    isAnimated,
    title,
    intro,
    cards
}: ContactCardsProps) {
    return (
        <Section className={clsx(
            'contact-cards-component',
            className
        )}>
            <div className='container'>

                {(title || intro) && (
                    <div className='contact-cards-component__top-wrapper'>

                        {title && (
                            <h2 className='h2 contact-cards-component__title'>
                                {title}
                            </h2>
                        )}

                        {intro && (
                            <div
                                className='lead-paragraph contact-cards-component__intro'
                                dangerouslySetInnerHTML={{
                                    __html: intro
                                }}
                            />
                        )}

                    </div>
                )}

                {cards && (
                    <div
                        className='contact-cards-component__cards'
                        data-stagger-scale={isAnimated ? 'true' : 'false'}
                    >
                        {cards?.map((item, i) => (
                            <ContactCard
                                key={i}
                                color={item.color}
                                image={item.image}
                                title={item.title}
                                position={item.position}
                                location={item.location}
                                tag={item.tag}
                                tag2={item.tag2}
                                phone={item.phone}
                                email={item.email}
                                href={item.href}
                            />
                        ))}
                    </div>
                )}

            </div>
        </Section>
    )
}